import styled from 'styled-components';

interface TitleStyledProps {
  children: string;
  fontSize?: number;
  color?: string;
}

const TitleStyled = styled.h3<TitleStyledProps>`
  font-style: normal;
  font-weight: bold;
  line-height: 24px;
  color: ${({ color }) => color};
  font-size: ${({ fontSize }) => `${fontSize}px`};

  &.optional {
    &::after {
      content: ' (opcional)';
      color: #999;
      font-weight: normal;
    }
  }
`;

export default TitleStyled;
export { TitleStyled };
